import $ from "jquery";

$(function () {
	$("#partSearch").on("submit", (e) => {
		e.preventDefault();
		fetch();
	});
});
